module.exports = __webpack_public_path__ + "static/olivier-c0b2e9c2773bb5a9317dc8718dfade1d.jpeg";